const anchor = {
  enable: () => {
    if (window.location.hash) {
      setTimeout(() => {
        const elm = document.getElementById(window.location.hash.slice(1))

        if (elm) {
          elm.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest',
          })
        }
      }, 1000)
    }
  },
}

export default anchor
